import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Close, Search } from '../../rootAccess';


const SearchBox = ({ placeholder = 'Search', val, onChange = () => { }, autoFocus = false }) => {
   const [internalVal, setInternalVal] = useState('');


   const isControlled = typeof val === 'string';
   const inputVal = isControlled ? val : internalVal;

   const handleChange = newVal => {
      if (!isControlled) {
         setInternalVal(newVal);
      }
      onChange(newVal);
   };

   const handleClear = () => {
      if (!isControlled) {
         setInternalVal('');
      }
      onChange('');
   };

   return (
      <div className={`search ${inputVal ? "typingValue" : ""}`}>
         <input
            type="text"
            className="search-contacts"
            name="search-contacts"
            autoComplete="off"
            placeholder={placeholder}
            value={inputVal}
            onChange={e => handleChange(e.target.value)}
            autoFocus={autoFocus}
         />
         {!inputVal ? (
            <i type="button" className="Search" title="Search">
               <Search />
            </i>
         ) : (
            <button type="button" className="CloseSearch" title="Clear search" onClick={handleClear}>
               <Close />
            </button>
         )}
      </div>
   );
};

SearchBox.propTypes = {
   placeholder: PropTypes.string,
   val: PropTypes.string,
   onChange: PropTypes.func,
   autoFocus: PropTypes.bool,
};

export default SearchBox;
